import Axios from "axios"
import {
    getToken
} from "./constants.js";
import qs from "qs";
import {
    getAuthApiBaseUrl
} from "./constants";

// const JIAN_QUAN_HOST = "https://api.yunhaogroup.com/auth";
// const HUAN_YUAN_HOST = "http://49.232.194.199:9100";   //库存
const service = Axios.create({
    // baseURL: "",
    timeout: 1000 * 20
})

// 添加请求拦截器s
service.interceptors.request.use(
    config => {
        config.headers["Authorization"] = getToken()
        return config
    },
    error => {
        Promise.reject(error)
    }
)
// 添加响应拦截器
service.interceptors.response.use(
    response => {

        const res = response
        if (res.status === 200) {
            return res.data
        }
    },
    error => {
        return Promise.reject(error) //千万不能去掉，，，否则请求超时会进入到then方法，导致逻辑错误。
    }
)

//根据token拿到用户信息
function getUser() {
    return service({

        // url: `http://api-cs.laoniuche.cn/auth/authUser/findUserById`,  // 部门测试用获取用户信息  TEST
        url: `${getAuthApiBaseUrl()}/authUser/findUserById`, // 正式版获取用户信息 PROD
        method: "get"
    })
}

// 根据token查询角色及应用的接口
function TokenMenu() {
    return service({
        // url: `http://api-cs.laoniuche.cn/auth/authUser/selectTokenByRoles`,  // 部门测试用获取用户信息  TEST        
        url: `${getAuthApiBaseUrl()}/authUser/selectTokenByRoles`,
        method: "get"
    })
}

//根据token查询角色及应用
function findMenu(data) {
    return service({
        // url: `http://api-cs.laoniuche.cn/auth/authUser/selectByMenu`,  // 部门测试用获取用户信息  TEST        
        url: `${getAuthApiBaseUrl()}/authUser/selectByMenu`,
        method: "get",
        params: data
    })
}

// //配件库存
// function getPartList(data) {
//     return service.post(
//         `${HUAN_YUAN_HOST}/vrm/select`,
//         qs.stringify(data),
//         { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
//     );
// }
// //根据库存id匹配
// function getPartAll(data) {
//     return service.post(
//         `${HUAN_YUAN_HOST}/vrm/find`,
//         data,
//         // { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
//     );
// }
export {
    getUser,
    findMenu,
    TokenMenu,
    // getPartList,
    // getPartAll
};